import dayjs from 'dayjs';

export const convertDayjsToEpoch = (value: any): any  => {
  if (dayjs.isDayjs(value)) {
    return value.valueOf();
  }

  if (Array.isArray(value)) {
    return value.map(convertDayjsToEpoch);
  }

  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [k, convertDayjsToEpoch(v)])
    );
  }

  return value;
}